import Textarea from 'components/Textarea/Textarea';

import './FormTextarea.scss';

interface IProps {
  name?: string;
  value: string;
  onChange?: (e: string) => void;
  placeholder?: string;
  label?: string;
}

const FormTextarea = ({name = '', value = '', onChange = () => {}, placeholder = '', label = ''}: IProps) => {
  return (
    <div className={`form-textarea ${value ? 'form-textarea--input' : ''}`}>
      <label className="form-textarea__label">{label}</label>
      <Textarea value={value} placeholder={placeholder} name={name} onChange={(e) => onChange(e.target.value)} />
    </div>
  );
};

export default FormTextarea;
